import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AssignmentReleaseScopeQueryVariables = Types.Exact<{
  assignmentId: Types.Scalars['ID']['input'];
  asEducatorId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type AssignmentReleaseScopeQuery = { __typename?: 'RootQueryType', assignmentsAsEducator?: { __typename?: 'KeysetPageOfAssignment', results?: Array<{ __typename?: 'Assignment', id: string, countOfSubmittedManuallyGradedGuesses: number, countOfUngradedGuesses: number, countOfGradingInProgressGuesses: number, countOfReleasableGradedGuesses: number }> | null } | null };


export const AssignmentReleaseScopeDocument = gql`
    query AssignmentReleaseScope($assignmentId: ID!, $asEducatorId: ID) {
  assignmentsAsEducator(
    filter: {id: {eq: $assignmentId}}
    first: 1
    asEducatorId: $asEducatorId
  ) {
    results {
      id
      countOfSubmittedManuallyGradedGuesses
      countOfUngradedGuesses
      countOfGradingInProgressGuesses
      countOfReleasableGradedGuesses
    }
  }
}
    `;

/**
 * __useAssignmentReleaseScopeQuery__
 *
 * To run a query within a React component, call `useAssignmentReleaseScopeQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignmentReleaseScopeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignmentReleaseScopeQuery({
 *   variables: {
 *      assignmentId: // value for 'assignmentId'
 *      asEducatorId: // value for 'asEducatorId'
 *   },
 * });
 */
export function useAssignmentReleaseScopeQuery(baseOptions: Apollo.QueryHookOptions<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables> & ({ variables: AssignmentReleaseScopeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>(AssignmentReleaseScopeDocument, options);
      }
export function useAssignmentReleaseScopeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>(AssignmentReleaseScopeDocument, options);
        }
// @ts-ignore
export function useAssignmentReleaseScopeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>): Apollo.UseSuspenseQueryResult<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>;
export function useAssignmentReleaseScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>): Apollo.UseSuspenseQueryResult<AssignmentReleaseScopeQuery | undefined, AssignmentReleaseScopeQueryVariables>;
export function useAssignmentReleaseScopeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>(AssignmentReleaseScopeDocument, options);
        }
export type AssignmentReleaseScopeQueryHookResult = ReturnType<typeof useAssignmentReleaseScopeQuery>;
export type AssignmentReleaseScopeLazyQueryHookResult = ReturnType<typeof useAssignmentReleaseScopeLazyQuery>;
export type AssignmentReleaseScopeSuspenseQueryHookResult = ReturnType<typeof useAssignmentReleaseScopeSuspenseQuery>;
export type AssignmentReleaseScopeQueryResult = Apollo.QueryResult<AssignmentReleaseScopeQuery, AssignmentReleaseScopeQueryVariables>;